import { createContext, useContext } from "react";
import { useAuth } from "../useAuth";
import { CustomScreen, ScreenInfoReturnProps } from "./types";
import reloadPage from "../../utils/AndroidBridge";

const screenInfoContext = createContext<ScreenInfoReturnProps | null>(null);
const { Provider } = screenInfoContext;
type Props = {
  children: React.ReactNode;
  initialScreenInfo: CustomScreen | null;
};
export function ScreenInfoProvider({ children }: Props) {
  const { storeOrgId, storeDeviceId, getScreenInfo, screenInfo } = useAuth();
  const musicInfos = screenInfo?.music_infos || []

  function onScreenChanged(data: any) {
    if (data?.new?.deleted) {
      storeOrgId(undefined);
      storeDeviceId(undefined);
      return reloadPage()
    }
    getScreenInfo(true)
  }

  function onLayoutChanged(_data: any) {
    getScreenInfo(true)
  }

  function onPlaylistChanged(_data: any) {
    getScreenInfo(true)
  }

  return (
    <Provider
      value={{
        onScreenChanged,
        onLayoutChanged,
        onPlaylistChanged,
        musicInfos: musicInfos || [],
      }}
    >
      {children}
    </Provider>
  );
}

export const useScreenInfo: () => ScreenInfoReturnProps = () => {
  const context = useContext(screenInfoContext);
  if (!context) throw "useScreens must be used within a ScreensProvider";
  return context;
};